export const EDIT_TEXT = 'Edit'
export const IMPLEMENTATION_APPROACH_LABEL_TEXT = 'Implementation Approach'
export const PURPOSE_STATEMENT_LABEL_TEXT = 'Purpose Statement'
export const GOALS_LABEL_TEXT = 'Goals'
export const PROGRAM_START_DATE_LABEL_TEXT = 'Program Start Date'
